import React from "react";
import { Box, VStack, Flex, Tooltip, Text, Tag } from "@chakra-ui/react";
import { formatDate } from "utils/dateUtils/dateUtils";

interface IssueCardProps {
  issue: any;
  handleIssueDetails: any;
  setSelectedIds: any;
}

export default function IssueCardView({
  issue,
  handleIssueDetails,
  setSelectedIds,
}: IssueCardProps): JSX.Element {
  const transaction = issue?.transaction;

  const customerMobile =
    transaction?.billingDetails?.phone ||
    transaction?.user_id?.moNumber ||
    "NA";

  const transactionId = transaction?._id || "NA";

  return (
    <Box
      p={3}
      borderRadius="md"
      shadow="base"
      bg="white"
      onClick={() => {
        handleIssueDetails(issue);
        setSelectedIds({
          issueId: issue?.issue_id,
          transactionId: issue?.transaction_id,
        });
      }}
    >
      <VStack align="start" spacing={2}>
        <Flex justify="space-between" w="full">
          <Tooltip label={issue?.issue_id} hasArrow>
            <Text
              fontSize="sm"
              fontWeight="bold"
              color="blue.500"
              isTruncated
              maxW="10rem"
              cursor="pointer"
            >
              {issue?.issue_id}
            </Text>
          </Tooltip>

          <Tag
            colorScheme={
              issue?.status === "OPEN"
                ? "green"
                : issue?.status === "PROCESSING" ||
                  issue?.status === "RESOLVED"
                  ? "blue"
                  : "red"
            }
            size="sm"
          >
            {issue?.status}
          </Tag>
        </Flex>

        <Text fontSize="sm">
          Customer Mobile: {customerMobile}
        </Text>

        <Tooltip label={issue?.short_desc} hasArrow>
          <Text fontSize="sm" isTruncated>
            Description: {issue?.short_desc || "NA"}
          </Text>
        </Tooltip>

        <Text fontSize="sm">
          Category: {issue?.category?.label || "NA"}
        </Text>

        <Tooltip label={transactionId} hasArrow>
          <Text fontSize="sm" isTruncated>
            Transaction ID: {transactionId}
          </Text>
        </Tooltip>

        <Text fontSize="sm">
          Requested On: {formatDate(issue?.createdAt, "DD-MM-YYYY")}
        </Text>
      </VStack>
    </Box>
  );
}